import CryptoJS from "crypto-js";

class ReactSecurityHelper {
  // 🔐 SECRET KEY - Should match backend
  static SECRET_KEY = "C#9@x$T%L7&Q*2m!K@4p#L$8z%778&&&*$#&1w*Y@6nen$C%3d&F*5h!J@7";
  static APP_VERSION = "2.0.6";
  static DeviceId = "Clients-Portal-PDC";

  static getDeviceId() {
    return this.DeviceId;
  }

  /**
   * Generate random nonce
   * @returns {string} Base64 encoded nonce
   */
  static generateNonce() {
    return CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Base64);
  }

  /**
   * Create HMAC signature for API request
   * @param {string} method - HTTP method (GET, POST, etc.)
   * @param {string} path - API path with query string
   * @param {string} timestamp - ISO timestamp
   * @param {string} nonce - Random nonce
   * @param {string} deviceId - Device ID
   * @returns {string} Base64 encoded signature
   */
  static createSignature(
        timestamp,
 path,
 deviceId,
    method,
    nonce,
  ) {
    const payloadParts = [
      timestamp,
      path.toUpperCase(),
      deviceId,
      method.toUpperCase(),
      nonce,
    ];

    const payload = payloadParts.join("\n");

    const signature = CryptoJS.HmacSHA256(payload, this.SECRET_KEY).toString(
      CryptoJS.enc.Base64,
    );

    // Debug: Print signature and its order
    console.log("=== SIGNATURE DEBUG ===");
    console.log("1. Timestamp:", timestamp);
    console.log("2. Path (UPPER):", path);
    console.log("3. Device ID:", deviceId);
    console.log("4. Method (UPPER):", method);
    console.log("5. Nonce:", nonce);
    // console.log("Payload (joined with \\n):", payload);
    // console.log("Final Signature:", signature);
    console.log("=====================");

    return signature;
  }

  /**
   * Create security headers for API request
   * @param {string} method - HTTP method
   * @param {string} path - API path
   * @returns {Object} Security headers
   */
  static createHeaders(method, path) {
    const timestamp = new Date().toISOString();
    const nonce = this.generateNonce();
    const deviceId = this.getDeviceId();

    // Extract path starting from /api for signature (domain-independent)
    let pathForSignature = path;
    const apiIndex = path.indexOf("/api");
    if (apiIndex !== -1) {
      pathForSignature = path.substring(apiIndex).toUpperCase();
    }

    const signature = this.createSignature(
      timestamp,
      pathForSignature,
      deviceId,
      method,
      nonce,
    );

    return {
      "X-App-Timestamp": timestamp,
      "X-App-Signature": signature,
      "X-App-Nonce": nonce,
      "X-App-Device": deviceId,
      "X-App-Version": this.APP_VERSION,
    };
  }
}

export default ReactSecurityHelper;
